module.exports = __webpack_public_path__ + "static/fonts/element-icons.535877f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/element-icons.woff
// module id = 61FY
// module chunks = 78